var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8384 20C5.31804 19.994 0.844441 15.5204 0.838379 10V9.80002C0.94831 4.30455 5.47297 -0.0720257 10.9691 0.000898217C16.4651 0.0738221 20.8721 4.5689 20.8362 10.0654C20.8003 15.5618 16.3349 19.9989 10.8384 20ZM6.24838 9.59002L4.83838 11L8.83838 15L16.8384 7.00002L15.4284 5.58002L8.83838 12.17L6.24838 9.59002Z",
    fill: "#29A64A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.90315dd0d50d861891c9810dcaed8879.svg";
export { ForwardRef as ReactComponent };